/* global axios */
import ApiClient from '../ApiClient';

// Client for conversation-scoped agent feedback. Topic discriminates what the
// feedback is about (ai_suggestion / email_sync / workflow / other). ai_draft_id
// is optional — when the agent is reacting to a specific AI draft we pass it,
// otherwise the report is anchored only to the conversation.
class FeedbackReportsApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create(conversationId, { topic, rating, categories, comment, aiDraftId }) {
    return axios.post(`${this.url}/${conversationId}/feedback_reports`, {
      topic,
      rating,
      categories,
      comment,
      ai_draft_id: aiDraftId,
    });
  }
}

export default new FeedbackReportsApi();
